import React, { useEffect, useState } from 'react';
import {
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
} from 'mdbreact';

function jaInstalado() {
  return (
    (window.matchMedia &&
      window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  );
}

function ehIOS() {
  return (
    /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream
  );
}

// Botão "Instalar app": no Android/desktop dispara o prompt NATIVO de
// instalação (só aparece quando o app é instalável — captura o evento
// beforeinstallprompt); no iOS (que não tem esse evento) abre um mini-guia.
// Some sozinho se o app já estiver rodando instalado (standalone) ou quando
// não é instalável (ex.: em dev, sem service worker).
export default function InstallButton() {
  const [prompt, setPrompt] = useState(null);
  const [instalado, setInstalado] = useState(jaInstalado());
  const [guiaIOS, setGuiaIOS] = useState(false);

  useEffect(() => {
    const onPrompt = e => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => {
      setInstalado(true);
      setPrompt(null);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (instalado) return null;
  const ios = ehIOS();
  if (!prompt && !ios) return null;

  const instalar = async () => {
    if (ios) {
      setGuiaIOS(true);
      return;
    }
    prompt.prompt();
    const escolha = await prompt.userChoice;
    if (escolha && escolha.outcome === 'accepted') setInstalado(true);
    setPrompt(null);
  };

  return (
    <>
      <button
        type="button"
        onClick={instalar}
        style={{
          marginTop: '.75rem',
          background: '#212121',
          color: '#fff',
          border: 0,
          borderRadius: 8,
          padding: '.6rem 1.2rem',
          fontSize: '.9rem',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        <MDBIcon icon="download" className="mr-2" />
        Instalar app
      </button>

      <MDBModal isOpen={guiaIOS} toggle={() => setGuiaIOS(false)}>
        <MDBModalHeader toggle={() => setGuiaIOS(false)}>
          Instalar no iPhone / iPad
        </MDBModalHeader>
        <MDBModalBody>
          No <strong>Safari</strong>, toque no bot&atilde;o{' '}
          <strong>Compartilhar</strong> <MDBIcon icon="share-square" /> e depois
          em <strong>Adicionar &agrave; Tela de In&iacute;cio</strong>.
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="dark" onClick={() => setGuiaIOS(false)}>
            Entendi
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    </>
  );
}
